import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'

const useNavigationAuthorization = (): boolean =>
  useSelector((state: RootState): boolean => state.auth.user.info?.hasRoles ?? false)

export default useNavigationAuthorization
